import { Upload, BrainCircuit, Bell, Download } from "lucide-react";

export const steps = [
  {
    Icon: Upload,
    label: "INPUT",
    labelColor: "text-blue-400",
    title: "Paste or Upload",
    desc: "Input your privacy policy via text paste, URL fetch, or direct file upload (PDF, DOCX).",
    highlight: false,
    hoverBorder: "hover:border-blue-500/60",
    iconActive: "text-blue-400",
    iconBg: "rgba(30,42,64,0.8)",
    iconBgHover: "bg-blue-500/20",
    cardBg: "rgba(22,27,39,0.8)",
    border: "border-slate-700/60",
    hoverBg: "hover:bg-blue-500/10",
  },
  {
    Icon: BrainCircuit,
    label: "ANALYZE",
    labelColor: "text-purple-400",
    title: "AI Analysis",
    desc: "Our AI engine scans every clause, cross-references regulations, and scores risk levels in seconds.",
    highlight: false,
    hoverBorder: "hover:border-purple-500/60",
    iconActive: "text-purple-400",
    iconBg: "rgba(30,42,64,0.8)",
    iconBgHover: "bg-purple-500/20",
    cardBg: "rgba(22,27,39,0.8)",
    border: "border-slate-700/60",
    hoverBg: "hover:bg-purple-500/10",
  },
  {
    Icon: Bell,
    label: "MONITOR",
    labelColor: "text-orange-400",
    title: "Policy Change Alerts",
    desc: "We continuously monitor tracked policies. The moment one is updated, you receive instant notifications detailing exactly what changed.",
    highlight: true,
    hoverBorder: "hover:border-orange-500/80",
    iconActive: "text-orange-300",
    iconBg: "rgba(232,93,74,0.2)",
    iconBgHover: "bg-orange-500/30",
    cardBg: "rgba(232,93,74,0.15)",
    border: "border-orange-500/50",
    hoverBg: "",
  },
  {
    Icon: Download,
    label: "EXPORT",
    labelColor: "text-green-400",
    title: "Review &amp; Export",
    desc: "Get a detailed structured report with actionable fixes and export it for your legal team or compliance audit.",
    highlight: false,
    hoverBorder: "hover:border-green-500/60",
    iconActive: "text-green-400",
    iconBg: "rgba(30,42,64,0.8)",
    iconBgHover: "bg-green-500/20",
    cardBg: "rgba(22,27,39,0.8)",
    border: "border-slate-700/60",
    hoverBg: "hover:bg-green-500/10",
  },
];
